import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faXmark,
  faHeart,
  faLock,
  faEnvelope,
  faGear,
  faMoneyCheckDollar,
  faCreditCard,
  faLink,
  faKey,
  faBookOpen,
  faUser,
  faCircleInfo,
  faStar,
} from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';

import 'Components/Account/AccountNavigation.scss';

export default function AccountNavigation({ location: { pathname } }) {
  const [collapseMenu, setCollapseMenu] = useState(false);

  const navigationLinkClick = () => {
    setCollapseMenu(false);
  };

  return (
    <nav aria-label="account-navigation" className={classNames('account-navigation', { 'menu-open': collapseMenu })}>
      <button className="account-navigation-link account-mobile-menu" onClick={() => { setCollapseMenu(!collapseMenu); }}>
        <div className="link-icon-container">
          {!collapseMenu &&
            <FontAwesomeIcon icon={faBars} title="Open menu" />
          }
          {collapseMenu &&
            <FontAwesomeIcon icon={faXmark} title="Close menu" />
          }
        </div>
        <div className="link-name-container">
          <FormattedMessage id="address-navigation.link.menu" defaultMessage="Account Menu" />
        </div>
      </button>

      <div className="account-navigation-links-container">
        <div className="account-navigation-link-group">
          <Link to="/account" className={classNames('account-navigation-link top-link', { active: pathname === '/account' })} onClick={navigationLinkClick}>
            <div className="link-icon-container">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <div className="link-name-container">
              <FormattedMessage id="address-navigation.link.account-overview" defaultMessage="Account Overview" />
            </div>
          </Link>

          <Link to="/account/login" className={classNames('account-navigation-link secondary-link', { active: pathname === '/account/login' || pathname === '/connections' })} onClick={navigationLinkClick}>
            <div className="link-icon-container" />
            <div className="link-name-container">
              <div className="secondary-link-container">
                <div className="secondary-link-icon-container">
                  <FontAwesomeIcon icon={faLock} />
                </div>
                <div className="secondary-link-name-container">
                  <FormattedMessage id="address-navigation.link.login-security" defaultMessage="Login & Security" />
                </div>
              </div>
              <div className="secondary-divider" />
            </div>
          </Link>

          <Link to="/account/payment" className={classNames('account-navigation-link secondary-link', { active: pathname === '/account/payment' })} onClick={navigationLinkClick}>
            <div className="link-icon-container" />
            <div className="link-name-container">
              <div className="secondary-link-container">
                <div className="secondary-link-icon-container">
                  <FontAwesomeIcon icon={faCreditCard} />
                </div>
                <div className="secondary-link-name-container">
                  <FormattedMessage id="address-navigation.link.payment-information" defaultMessage="Payment Information" />
                </div>
              </div>
              <div className="secondary-divider" />
            </div>
          </Link>

          <Link to="/account/contact" className={classNames('account-navigation-link secondary-link', { active: pathname === '/account/contact' || pathname === '/account/preferencecenter' })} onClick={navigationLinkClick}>
            <div className="link-icon-container" />
            <div className="link-name-container">
              <div className="secondary-link-container">
                <div className="secondary-link-icon-container">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <div className="secondary-link-name-container">
                  <FormattedMessage id="address-navigation.link.contact-preferences" defaultMessage="Contact Preferences" />
                </div>
              </div>
              <div className="secondary-divider" />
            </div>
          </Link>

          <Link to="/account/linked-accounts" className={classNames('account-navigation-link secondary-link', { active: pathname === '/account/linked-accounts' })} onClick={navigationLinkClick}>
            <div className="link-icon-container" />
            <div className="link-name-container">
              <div className="secondary-link-container">
                <div className="secondary-link-icon-container">
                  <FontAwesomeIcon icon={faLink} />
                </div>
                <div className="secondary-link-name-container">
                  <FormattedMessage id="address-navigation.link.linked-accounts" defaultMessage="Linked Accounts" />
                </div>
              </div>
              <div className="secondary-divider" />
            </div>
          </Link>

          <Link to="/account/settings" className={classNames('account-navigation-link secondary-link', { active: pathname === '/account/settings' })} onClick={navigationLinkClick}>
            <div className="link-icon-container" />
            <div className="link-name-container">
              <div className="secondary-link-container">
                <div className="secondary-link-icon-container">
                  <FontAwesomeIcon icon={faGear} />
                </div>
                <div className="secondary-link-name-container">
                  <FormattedMessage id="address-navigation.link.website-settings" defaultMessage="Website Settings" />
                </div>
              </div>
              <div className="secondary-divider" />
            </div>
          </Link>
        </div>

        <Link to="/orders" className={classNames('account-navigation-link', { active: pathname === '/orders' || pathname.startsWith('/orders/') })} onClick={navigationLinkClick}>
          <div className="link-icon-container">
            <FontAwesomeIcon icon={faKey} />
          </div>
          <div className="link-name-container">
            <FormattedMessage id="address-navigation.link.order-history-keys" defaultMessage="Order History & Keys" />
          </div>
        </Link>

        <Link to="/product-library" className={classNames('account-navigation-link', { active: pathname === '/product-library' })} onClick={navigationLinkClick}>
          <div className="link-icon-container">
            <FontAwesomeIcon icon={faBookOpen} />
          </div>
          <div className="link-name-container">
            <FormattedMessage id="address-navigation.link.library" defaultMessage="Product Library" />
          </div>
        </Link>

        <Link to="/account/wishlist" className={classNames('account-navigation-link', { active: pathname === '/account/wishlist' })} onClick={navigationLinkClick}>
          <div className="link-icon-container">
            <FontAwesomeIcon icon={faHeart} />
          </div>
          <div className="link-name-container">
            <FormattedMessage id="address-navigation.link.wishlist" defaultMessage="Wishlist" />
          </div>
        </Link>

        <Link to="/reviews" className={classNames('account-navigation-link', { active: pathname === '/reviews' || pathname.startsWith('/review/') })} onClick={navigationLinkClick}>
          <div className="link-icon-container">
            <FontAwesomeIcon icon={faStar} />
          </div>
          <div className="link-name-container">
            <FormattedMessage id="address-navigation.link.reviews" defaultMessage="My Reviews" />
          </div>
        </Link>

        <Link to="/account/rewards" className={classNames('account-navigation-link', { active: pathname === '/account/rewards' })} onClick={navigationLinkClick}>
          <div className="link-icon-container">
            <FontAwesomeIcon icon={faMoneyCheckDollar} />
          </div>
          <div className="link-name-container">
            <FormattedMessage id="address-navigation.link.rewards" defaultMessage="Coupons & Rewards" />
          </div>
        </Link>

        <Link to="/support" className={classNames('account-navigation-link', { active: pathname === '/support' })} onClick={navigationLinkClick}>
          <div className="link-icon-container">
            <FontAwesomeIcon icon={faCircleInfo} />
          </div>
          <div className="link-name-container">
            <FormattedMessage id="address-navigation.link.support" defaultMessage="Support" />
          </div>
        </Link>
      </div>
    </nav>
  );
}

AccountNavigation.propTypes = {
  location: PropTypes.shape({}).isRequired,
};
